// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAa4j3wZdw8d-PqmCD_BfuQ7f9Nm75zrL4",
  authDomain: "tgh-admin-897f1.firebaseapp.com",
  projectId: "tgh-admin-897f1",
  storageBucket: "tgh-admin-897f1.firebasestorage.app",
  messagingSenderId: "188948859607",
  appId: "1:188948859607:web:66e85be9cde0f78f6cfe92"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const storage = getStorage(app);
export const auth = getAuth(app);

export default storage